export interface IIdvDuplicationMatch {
    user_id: string;
    first_name: string;
    last_name: string;
    score: number;
}

export interface IIdvDuplicationMatchesResponse {
    duplication_matches: IIdvDuplicationMatch[];
}
